// extracted by mini-css-extract-plugin
module.exports = {"styleTextContainer":"Admin_styleTextContainer__1JIzV","styleDiv":"Admin_styleDiv__257_2"};